import { Injectable, Output, EventEmitter } from "@angular/core";
import { HttpClient, HttpHeaders } from "@angular/common/http";

@Injectable({
  providedIn: "root",
})
export class ImageService {
  public imageLoaded = new EventEmitter();
  public images = new Map();

  constructor(private http: HttpClient) {}

  /**
   *
   * @param data es la configuración
   * @param maxTextureSize es el tamaño de la maxima textura soportada
   * @param nextEnvs las imágenes a cargar primero
   */
  public downloadImages(data, maxTextureSize, nextEnvs) {
    let idImageLink = new Map();
    data.environments.map((e) => {
      //Agrego la imagen según la capacidad del dispositivo
      let image = e.image;
      if (maxTextureSize <= 4096) {
        image = image.replace("4k", "2k");
      }
      idImageLink.set(e.id, image);
    });

    //Descargo las que tiene prioridad
    let promises = [];
    nextEnvs.forEach((id) => {
      promises.push(this.downloadOneImage(idImageLink.get(id), id));
    });
    Promise.all(promises).then((e) => {
      this.imageLoaded.emit(e);
      //Descargo las restantes
      idImageLink.forEach((k, v) =>
        this.downloadOneImage(k, v).then((id) => this.imageLoaded.emit(id))
      );
    });
  }

  private downloadOneImage(url, id): any {
    return new Promise((resolve, reject) => {
      if (!this.images.get(id)) {
        this.http
          .get(`${url}`, {
            headers: {
              "Access-Control-Allow-Headers": "Content-Type",
              "Access-Control-Allow-Methods": "GET",
              "Access-Control-Allow-Origin": "*",
            },
            responseType: "blob",
          })
          .subscribe(
            (img) => {
              const imgStatus = new Map();
              imgStatus.set("error", false);
              imgStatus.set("file", img);
              this.images.set(id, imgStatus);
              resolve(id);
            },
            (error) => {
              const imgStatus = new Map();
              imgStatus.set("error", true);
              imgStatus.set("url", url);
              this.images.set(id, imgStatus);
              resolve(id);
            }
          );
      } else {
        resolve(id);
      }
    });
  }
}
